export const white = '#EFE1EF';
export const paperWhite = '#FFF';
export const darkGreen = '#292B30';
export const black = '#100E1C';
export const yellow = '#ffec00';
export const orange = '#B53A2D';
export const red = '#ff3300';
export const blue = '#61e5ff';
export const lightBlue = '#b4f3ff';
export const darkBlue = '#342c9e';

export const nightBlue = `linear-gradient(${black} 0%, ${darkBlue} 20%)`;
export const morningYellow = `linear-gradient(${yellow} 0%, ${orange} 20%)`;
export const dayBlue = `linear-gradient(${blue} 0%, ${lightBlue} 30%)`;

// I'm randomly assining these... all dnned to be updated
export const darkRed = '#5f0f40';
export const brightOrange = '#fb8b24';
export const pink = '#f28482';
export const teal = '#00a896';

export const colorLoop = [darkRed, brightOrange, pink, teal];
